import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";

import { AuthProvider } from "@/lib/auth";

import HomePage from "@/pages/HomePage";
import ArticlePage from "@/pages/ArticlePage";
import ListingPage from "@/pages/ListingPage";
import AboutPage from "@/pages/AboutPage";
import ContactPage from "@/pages/ContactPage";

import AdminLogin from "@/pages/admin/AdminLogin";
import AdminDashboard from "@/pages/admin/AdminDashboard";
import ArticlesAdmin from "@/pages/admin/ArticlesAdmin";
import ArticleEditor from "@/pages/admin/ArticleEditor";
import CategoriesAdmin from "@/pages/admin/CategoriesAdmin";
import AuthorsAdmin from "@/pages/admin/AuthorsAdmin";
import BannersAdmin from "@/pages/admin/BannersAdmin";
import AdsAdmin from "@/pages/admin/AdsAdmin";
import CommentsAdmin from "@/pages/admin/CommentsAdmin";
import UsersAdmin from "@/pages/admin/UsersAdmin";

function App() {
  return (
    <div className="App">
      <AuthProvider>
        <BrowserRouter>
          <Toaster position="top-center" richColors />
          <Routes>
            <Route path="/" element={<HomePage />} />
            <Route path="/noticias" element={<ListingPage mode="news" />} />
            <Route path="/destaques" element={<ListingPage mode="featured" />} />
            <Route path="/ultimas" element={<ListingPage mode="latest" />} />
            <Route path="/populares" element={<ListingPage mode="popular" />} />
            <Route path="/busca" element={<ListingPage mode="search" />} />
            <Route path="/categoria/:slug" element={<ListingPage mode="category" />} />
            <Route path="/autor/:slug" element={<ListingPage mode="author" />} />
            <Route path="/noticia/:slug" element={<ArticlePage />} />
            <Route path="/sobre" element={<AboutPage />} />
            <Route path="/contato" element={<ContactPage />} />

            <Route path="/admin/login" element={<AdminLogin />} />
            <Route path="/admin" element={<AdminDashboard />} />
            <Route path="/admin/noticias" element={<ArticlesAdmin />} />
            <Route path="/admin/noticias/:id" element={<ArticleEditor />} />
            <Route path="/admin/categorias" element={<CategoriesAdmin />} />
            <Route path="/admin/autores" element={<AuthorsAdmin />} />
            <Route path="/admin/banners" element={<BannersAdmin />} />
            <Route path="/admin/anuncios" element={<AdsAdmin />} />
            <Route path="/admin/comentarios" element={<CommentsAdmin />} />
            <Route path="/admin/usuarios" element={<UsersAdmin />} />
          </Routes>
        </BrowserRouter>
      </AuthProvider>
    </div>
  );
}

export default App;
